import { Tooltip } from "@mui/material";
import "./HeaderWithInfo.css";

const HeaderWithInfo = (props) => {
  const label = props?.displayName || props?.colDef?.headerName || props?.colDef?.field || "";
  const infoText = props?.infoText || "No additional info available.";
  const subLabel = props?.subLabel;

  return (
    <div className="table-header-with-info">
      <div className="table-header-text">
        <span className="table-header-title">{label}</span>
        {subLabel ? <span className="table-header-subtitle">{subLabel}</span> : null}
      </div>
      <Tooltip
        title={infoText}
        arrow
        enterDelay={150}
        leaveDelay={80}
        disableInteractive
        disableFocusListener
        disableTouchListener
      >
        <button
          type="button"
          className="table-header-info-button"
          onMouseDown={(event) => event.stopPropagation()}
          onClick={(event) => event.stopPropagation()}
          aria-label={`Info for ${label}`}
        >
          i
        </button>
      </Tooltip>
    </div>
  );
};

export default HeaderWithInfo;
